module.exports = __webpack_public_path__ + "media/site/images/icons/robot-icon-4e2548453375c99f81191f8b2df8dfc2.svg";